// extracted by mini-css-extract-plugin
module.exports = {"lineupContainer":"styles_lineupContainer__373dU","card":"styles_card__3t6WW","item":"styles_item__3IeJB","title":"styles_title__3t49_"};